import React, {useMemo} from "react";
import {Box, Chip, Typography} from "@mui/material";
import {Proposal} from "../../../types/Proposal";
import {priceRender} from "./proposalTableFunctions";

interface SelectedProposalsBannerProps {
    selectedData: Record<string, Proposal>;
    currentPageProposals: Proposal[];
    onRemove: (id: string) => void;
}

export function SelectedProposalsBanner({selectedData, currentPageProposals, onRemove}: SelectedProposalsBannerProps) {
    const offPageEntries = Object.values(selectedData);
    const hasOffPage = useMemo(() => {
        if(offPageEntries.length > currentPageProposals.length) {
            return true;
        }
        const ids = currentPageProposals.reduce((map, p) => {
            map[p.id] = true;
            return map;
        }, {} as Record<string, boolean>);
        for(let i = 0 ; i < offPageEntries.length; i++) {
            if(!ids[offPageEntries[i].id]) {
                return true;
            }
        }
        return false;
    }, [offPageEntries, currentPageProposals]);
    if (!hasOffPage) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                alignItems: 'center',
                p: 1,
                mb: 1,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                backgroundColor: 'action.hover',
            }}
        >
            <Typography variant="caption" color="text.secondary" sx={{mr: 0.5}}>
                PDF:
            </Typography>
            {offPageEntries.map(proposal => (
                <Chip
                    key={proposal.id}
                    size="small"
                    label={`${proposal.id.substring(0, 6)} · ${proposal.address || '—'} · ${priceRender(proposal.price)}`}
                    onDelete={() => onRemove(proposal.id)}
                />
            ))}
        </Box>
    );
}
